module.exports = __webpack_public_path__ + "media/packs/site/assets/images/illust_mail-ac7d8c8db17856b69bcb6ca40de0af69.png";